<template>
  <div v-if="order.status !== 0 && order.status !== 901" class="content">
    <div class="title">
      <div class="title-left">发票</div>
      <button
        v-if="order.invoiceStatus === 1"
        v-track="{
          name: '我的订单-修改发票信息',
          id: '123c83fd-7a21-44fa-aee7-f12fcd3f65a5',
        }"
        class="title-right"
        @click="toInvoice"
      >
        修改发票信息
        <x-icon name="arrow" />
      </button>
      <button
        v-if="order.invoiceStatus === 2"
        v-track="{
          name: '我的订单-查看发票',
          id: '516c46f9-a52f-499f-a742-3ba85cd2621c',
        }"
        class="title-right"
        @click="toWatch"
      >
        查看发票
        <x-icon name="arrow" />
      </button>
      <button
        v-if="order.invoiceStatus === 0"
        v-track="{
          name: '我的订单-申请开票',
          id: 'f8a212d0-60a9-4408-8878-fb8dfa452384',
        }"
        class="title-right"
        @click="toInvoice"
      >
        申请开票
        <x-icon name="arrow" />
      </button>
    </div>
    <div
      v-if="order.invoiceStatus === -1"
      class="tips"
      @click="handleContactClick"
    >
      请联系客服 <span>4009008799</span> 开票
    </div>
    <div v-if="order.invoiceStatus === 0" class="tips">
      *确认收货七天后自动开票
    </div>
  </div>
</template>

<script>
  import { dcb } from '@dcb/jssdk'
  export default {
    name: 'OrderInvoice',
    props: {
      order: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {}
    },
    // mounted() {},
    methods: {
      toInvoice() {
        this.$router.push({
          name: 'InvoiceRequest',
          query: {
            orderNo: this.order.orderNo,
          },
        })
      },
      toWatch() {
        this.$router.push({
          name: 'InvoiceDetail',
          query: {
            orderNo: this.order.orderNo,
          },
        })
      },

      handleContactClick() {
        dcb.makePhoneCall({
          phoneNumber: '4009008799',
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  .content {
    background: #ffffff;
    border-radius: 8px;
    margin-top: 10px;
    padding: 12px;
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-left {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
    }
    &-right {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #888888;
      display: flex;
      align-items: center;
      background-color: transparent;
      border: none;
      img {
        width: 18px;
        height: 18px;
      }
    }
  }
  .tips {
    margin-top: 4px;
    font-size: 12px;
    color: #888888;

    span {
      color: #018ff0;
    }
  }
</style>
